import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const content: SxStyle = {
  padding: (p) => p.spacing(0, 1, 1, 1),
  overflow: 'auto',
};
